import { render, staticRenderFns } from "./SelectInternalPageModal.vue?vue&type=template&id=31868b00&scoped=true&lang=pug"
import script from "./SelectInternalPageModal.vue?vue&type=script&lang=js"
export * from "./SelectInternalPageModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31868b00",
  null
  
)

export default component.exports